import { IgButton } from "@intelligems/ig-theme";
import { IgAppBanner } from "@src/components/Utils/IgAppBanner";
import { openNewTab } from "@src/utils/openNewTab";

import { SystemAlertResponse } from "../types";

import { VariantProp } from "./types";

interface SystemStatusAlertProps extends VariantProp {
  systemAlert: SystemAlertResponse | null | undefined;
}

export const SystemStatusAlert = ({
  additionalAlert,
  endContent,
  systemAlert,
}: SystemStatusAlertProps) => {
  if (!systemAlert) return null;

  const button = typeof systemAlert.buttonText === "string" &&
    typeof systemAlert.buttonUrl === "string" && (
      <IgButton
        key="connect"
        size="extraSmall"
        variant="contained"
        color={additionalAlert ? "primary" : "secondary"}
        onClick={() =>
          systemAlert.buttonUrl && openNewTab(systemAlert.buttonUrl)
        }
      >
        {systemAlert.buttonText}
      </IgButton>
    );

  const alertLevels = ["info", "alert"];
  const variant =
    systemAlert.level && alertLevels.includes(systemAlert.level)
      ? systemAlert.level
      : "alert";

  return (
    <IgAppBanner
      dismissId={systemAlert.dismissId}
      title={systemAlert.title}
      message={systemAlert.message}
      buttons={[button]}
      variant={additionalAlert ? "secondary" : variant}
      endContent={endContent}
    />
  );
};
